module.exports = __webpack_public_path__ + "img/background-todos.15e91789.jpg";